import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from './item';

export class PhoneInput extends Component {

  static propTypes = {
    value: PropTypes.string.isRequired,
    onChange : PropTypes.func.isRequired,
    showError: PropTypes.bool,
    showSuccess: PropTypes.bool,
    showOnChange: PropTypes.bool,
    showWarning: PropTypes.bool,
    showOnBlur: PropTypes.bool,
    onBlur: PropTypes.func,
    type: PropTypes.string,
    onCheck: PropTypes.func,
    disabled: PropTypes.bool
  };

  isValid(phone) {
    // eslint-disable-next-line no-useless-escape
    var re = /^(\+[0-9]{2}[.\-\s]?|00[.\-\s]?[0-9]{2}|0)([0-9]{1,3}[.\-\s]?(?:[0-9]{2}[.\-\s]?){4})$/gm;
    return re.test(phone);
  }

  render() {
    
    return (
      <Input
        icon="phone"
        placeholder= "Téléphone"
        isValid={ this.isValid }
        status={ { success : '' , error: 'Veuillez renseigner un numéro valide' } }
        checkOnChange
        required
        notEmpty
        { ...this.props }
        />
    );
  }
}

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/helper/form/input/phone.js